import { render, staticRenderFns } from "./peaMain.vue?vue&type=template&id=c66b0894&scoped=true"
import script from "./peaMain.vue?vue&type=script&lang=js"
export * from "./peaMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66b0894",
  null
  
)

export default component.exports